// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/chunks/" + (chunkId === 8875 ? "54272281" : chunkId) + "." + {"2390":"f2763016205937c4","8875":"e3127defa646feb3"}[chunkId] + ".js";
};